<template>
  <el-dialog
    :title="`${titleText}次数变更（批量）`"
    :visible.sync="isShow"
    width="450px"
    :before-close="handleClose"
  >
    <el-form :model="physicalBatchShipmentFrom">
      <el-form-item label="上传文件:" required>
        点击<el-button
          type="text"
          style="width: auto;"
          @click="handleDownloadTemplate"
          >下载模板</el-button
        >
        <el-upload
          :on-success="handleUpload"
          :show-file-list="false"
          class="upload-demo"
          :drag="true"
          multiple
          with-credentials
          :action="
            `/jd-hd-web/PointActivityEffectDetails/importGameTaskRecord?activityId=${activityId}`
          "
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="footer-btn">
      <el-button size="small" type="primary" @click="handleconfirm"
        >确定</el-button
      >
      <el-button size="small" class="quxiao_button" @click="handleClose"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    activityId: {
      type: String,
      default: "",
    },
    titleText: {
      type: String,
      default: "抽奖",
    },
  },
  data() {
    return {
      isShow: true,
      isUpload: false,
    };
  },
  methods: {
    handleconfirm() {
      if (!this.isUpload) {
        this.$message.warning("请上传文件");
        return;
      }
      this.$emit("close", true);
    },
    // 下载模板
    handleDownloadTemplate() {
      let url =
        "https://cdn-image.yucrm.cn/template/%E6%AC%A1%E6%95%B0%E5%8F%98%E6%9B%B4%E6%A8%A1%E6%9D%BF.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    },
    handleUpload(res) {
      // 上传文件
      this.isUpload = true;
      if (res.code == 0) {
        this.$message.error(res.message);
      } else if (res.code == 1) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
    handleClose() {
      if (this.isUpload) {
        this.$emit("close", true);
      } else {
        this.$emit("close", false);
      }
    },
    handleconfirm() {
      if (!this.isUpload) {
        this.$message.warning("请上传文件");
        return;
      }
      this.$emit("close", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-demo {
  margin-top: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  /deep/ .el-upload .el-upload-dragger {
    width: 400px;
  }
}
.downloadMsgBox {
  margin: 20px auto;
  width: 100%;
  line-height: 0;
  .downloadUser {
    margin-top: 12px;
    line-height: 20px;
    margin-left: 16px;
  }
}

.footer-btn {
  text-align: right;
}
</style>
